module.exports = __webpack_public_path__ + "static/media/issue-active.a0e36259.svg";